import { render, staticRenderFns } from "./ModalAssignTo.vue?vue&type=template&id=2b89deb6&lang=pug&"
import script from "./ModalAssignTo.vue?vue&type=script&lang=js&"
export * from "./ModalAssignTo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignTo.vue?vue&type=style&index=0&id=2b89deb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports